
import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';
import constants from '../../../constants';
import Select from "../../../ui/Select";
import {Search} from "../../../filtering";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { IJobListViewContext, RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../ui/PrimaryButton';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from "../../../framework.core/JobNames";
import {OtherOperationListItem} from "../../../fms.data/models/OtherOperationListItem";
import {otherShipmentList} from "../tableSettings";
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, changeRQEvent, LastEventRenderer, RecognizedFilterRenderer, RecognizedRenderer, RQFilterEventRenderer, RQFilterRenderer, ShipmentTypeRenderer } from '../../common/commonListRenderers';
import * as XCol from '../../../framework.core/XExportColumn';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import postal from 'postal';
import loadInfoAreaInvoiceBillCrDb from '../../common/InfoAreaInvoiceBillCrDb';
import { FmsSecTask } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask, findSecurityTaskWithBranch, getSecBySecTask } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import _ from 'lodash';
import fastStorage from '../../../fastStorage';
import RecogModal from '../../../ui/RecogModal';
import useSetEditedId from '../../../hooks/useSetEditedId';
import TrackingRequest from '../../reports/TrackingRequest';
import MblMilestonePopup from './MblMilestonePopup';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton, { BillingsIconButton, DeleteHistoryIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, RecogHistoryIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import TrackingRQIcon2 from '../../../img/toolbar-trackingrq-light.svg';
import TrackingRQIcon2_D from '../../../img/toolbar-trackingrq-dark.svg';
import TrackingRQIcon3 from '../../../img/cntr-tracking-rq-light.svg';
import TrackingRQIcon3_D from '../../../img/cntr-tracking-rq-dark.svg';
import { Decimalformat, displayLastTrackingEvent, nullableCheckBoxValue } from '../../common/commonExportFormat';
import UseAMSISfIcon from '../../../img/Isf_P_circle.svg';
import CheckBoxIcon from "../../../ui/CheckBoxIcon";
import { SecType } from '../../../fms.enum';
import JobSwitchingMenuContext from '../../jobSwitchingMenuContext';
import useJobMenus from '../../../hooks/useJobMenus';
import { getTrackRequestTitle } from '../../../util/trackingRequestUtils';
import useListTrackingRequest from '../../../hooks/useListTrackingRequest';
import taskReminderIconRed from '../../../img/pin_red.svg';
import cntrBlue from '../../../img/cntr-tracking-rq-12-blue.svg';
import cntrGreen from '../../../img/cntr-tracking-rq-12-green.svg';
import SparkleIcon from '../../../img/ai-marker.svg';

function ShipmentTypeFilterRenderer({value, onChange}:any) {
  useEffect(() => {
      if (value !== unFormatShipmentType(value)) {
        onChange(unFormatShipmentType(value))
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <Select
      name='ifms-filter-shipmentType-select'
      value={unFormatShipmentType(value)}
      onChange={e => onChange(e.target.value)}
      items={[
        { label: 'D - Direct Shipment', value: 'D' },
        { label: 'ID - InDirect Shipment', value: 'I' }
      ]}      
    />
  );
}

function formatShipmentType(s:string|null|undefined) {
  if (!s) {
    return s;
  }

  if (s === 'I') {
    return 'ID';
  }
  if (s === 'D') {
    return 'D';
  }

  return s;
}

function unFormatShipmentType(s:string|null|undefined) {
  if (!s) {
    return '';
  }

  if (s === 'ID') {
    return 'I';
  }
  if (s === 'D') {
    return 'D';
  }

  return '';
}

// function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
//   return (
//     <div style={{height: '100%'}}>
//       <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
//         <CurrencyLabel currency={currency} value={value}/>
//       </div>
//     </div>
//   );
// }

function IndicatorRenderer({ data, row }: any) {
  //const jobListContext = useContext(JobListViewContext);
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';
  else if (lStatus === 'AC') dataTooltip = 'Accounting Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  //}
  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useSelectedOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}
/*
function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
  const entity = data[row.index];

  return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
    <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
            onClick={() => onLinkToAccounting(entity)}>{value}</button>
    &nbsp;
  </div>;
}
*/

function IsfRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const useIsf = (l as any).useIsf as boolean;

  if (useIsf) {
    if (cell && cell.value) {
      return (
        <div className="ifms-table-align-left" id={`ifms-table-align-left-${row.index}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '22px' }}><img height="13px" src={UseAMSISfIcon} alt="" /></div>
      );
    }
  } else {
    if (cell && cell.value) {
      return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default">
        <CheckBoxIcon value={true} />
      </div>;  
    }
  }

  return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
}

function InbondRenderer({ cell, row, data }: any) {
  const l = data[row.index];

  if (!!l.itNo) {
    if (cell && cell.value) {
      return (
        <div className="ifms-table-align-left" id={`ifms-table-align-left-${row.index}`}>{l.itNo}</div>
      );
    }
  } else {
    if (cell && cell.value) {
      return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
    }
  }
  return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
}

function ContainerRenderer({ cell, value, data, row }: any) {
  const l = data[row.index];
  return (
    <div className="ifms-table-default" id={`ot-container-${cell.column.id}`} data-tooltip={l.fullContainer}>{value}</div>
  );
}

function MemoDetailRenderer({value, data, row}: any) {
  const {openDocServer} = useSelectedOperations();

  const memoCnt = value;

  if(memoCnt === '0'){
    return <div className="ifms-table-default">{value}</div>;
  }

  return <div onClick={() => openDocServer(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em', cursor:'pointer'}}>{value}</div>
}

function RefNoRenderer({value, data, row, cell}: any){
    
  const isPending = data[row.index].taskPendingCnt > 0;
  const isAiAgent = data[row.index].u1ID.toUpperCase() === '@AIAGENT';
    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">
      {value}
      {isAiAgent ? <img style={{marginBottom:'1px', marginLeft:'8px'}} src={SparkleIcon} /> : <></>}
      {isPending ? <img style={{marginBottom:'1px', marginLeft:'3px'}}width='11px' height='11px' src={taskReminderIconRed} />: <></>}
    </div>
}

function AgentRenderer({ cell, value, data, row }: any) {
  const agentCnt  = (data[row.index].agentCnt - 1);

  return ( 
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">{value}{agentCnt > 0 ? ' + ' + agentCnt : ''}</div>
  );
}


function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();

  const selectedElement = jobListContext.selectedElement as OtherOperationListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  const { trackRequestFunc } = useListTrackingRequest({
    jobName: JobNames.OtherOP,
    getMblNo: () => selectedElement?.mblNo ?? '',
    getContainerNo: () => selectedElement?.container ?? '',
    getTrType: () => selectedElement?.trType ?? '',
    getTrStatus: () => selectedElement?.trStatus ?? '',
    getJobId: () => selectedElement?.id ?? 0,
  });

  function openDocServer(ot:OtherOperationListItem|null){
    if (!ot) {
      return;
    }

    if(appContext.appInfoAreaContent === 'none') appContext.setAppInfoAreaContent('memo'); 
  }


  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/otherShipment/otherShipment/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, '/otherShipment/otherShipment/add', NavigationType.newPage);
  }

  async function deleteItem() {
    if (!selectedElement) {
      return;
    }

    // if (
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/edit/${selectedElement.id}`) || 
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/view/${selectedElement.id}`)
    // ) {
    //   await showGlobalOkDialog('Need to close B/L first', false, null, "warning");
    //   return;
    // }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/OTOP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/OTOP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/OTOP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/OTOP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/OTOP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/OTOP/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first.');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.OtherOP, { id:selectedElement.id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        // List에서 데이터를 Delete할 때 해당 데이터가 View/Edit 모드로 Open 되어있으면 그 탭을 Close하도록 동작
        const editUrl = `/otherShipment/otherShipment/edit/${selectedElement.id}`;
        const viewUrl = `/otherShipment/otherShipment/view/${selectedElement.id}`;
        if (jobListContext.hasOpenedScreenStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
            context.resetForCurrentJob();
            removeSingleJobMenuinTab(jobListContext.hasOpenedScreenStartingWithUrl(editUrl) ? editUrl : viewUrl, '');
        }
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 1;
    const baseUrl = '/otherShipment/otherShipment';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);
    
    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.OtherOP}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewProfit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 2;
    const baseUrl = '/otherShipment/otherShipment';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);
    
    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.OtherOP}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  async function moveToDeleteHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.OtDeleteHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    // if (!selectedElement) {
    //   return;
    // }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.OtherOP}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToRecogHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.OtRecogHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    // if (!selectedElement) {
    //   return;
    // }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/recogHistory?jobname=${JobNames.OtherOP}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/otherShipment/otherShipment/edit/${id}`;
    const viewUrl = `/otherShipment/otherShipment/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/otherShipment/otherShipment/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }
    
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/otherShipment/otherShipment/edit/${id}`;
    const viewUrl = `/otherShipment/otherShipment/view/${id}`;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OtherOP, selectedElement.branch);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/otherShipment/otherShipment/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/otherShipment/otherShipment/add?copyId=${id}`, NavigationType.newPage);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  async function switchToAcctInfo(ot:OtherOperationListItem|null) {
    if (!ot) {
      return;
    }
    
    openNewPage(history, `/accounting/Acct/${JobNames.OtherOP}/${ot.id}`, NavigationType.newPage);
  }

  function switchToContainerFor() {
    if (!selectedElement) {
      return;
    }
  
    jobListContext.setFilterForScreenExternally('/common/joblistview/OTOPC/otherShipment', 
      //'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false
      // 'refNo', '', mbl.refNo ?? '', 'update', false);
      'genMainId', 'Ref. #', selectedElement.id, '', false, true, null, 'refNo', selectedElement.refNo, false, true);
    openNewPage(history, `/common/joblistview/OTOPC/otherShipment`, NavigationType.newPage);
  }

  return {create, deleteItem, edit, view, copy, recognize, viewBillings, moveToDeleteHistoryReport, moveToRecogHistoryReport, switchToAcctInfo, viewProfit, switchToContainerFor, trackRequestFunc, openDocServer};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteItem, edit, view, copy, recognize, viewBillings, viewProfit, switchToContainerFor, trackRequestFunc } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OtherOperationListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OtherOP, selectedElement?.branch);
  const fmsGlobal = getFmsGlobal();
   const userID = appContext.user ? appContext.user.id ?? '' : '';


  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.OtherOP, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult);
      return;
    }

    const hasOpened =
    jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/edit/${selectedElement.id}`) ||
    jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/view/${selectedElement.id}`)


    if (selectedElement.isClosed && hasOpened) {
      const editModelKey = `editOtherShipment${selectedElement.id}-/otherShipment/otherShipment/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewModelKey = `viewOtherShipment${selectedElement.id}-/otherShipment/otherShipment/view`;
     const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 0;
        fastStorage[viewKeyMatch].isClosed = false;
        fastStorage[viewKeyMatch].closedBy = '';
        fastStorage[viewKeyMatch].closeDate = null;
      }
    } else if (!selectedElement.isClosed && hasOpened) {
      const editModelKey = `editOtherShipment${selectedElement.id}-/otherShipment/otherShipment/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewModelKey = `viewOtherShipment${selectedElement.id}-/otherShipment/otherShipment/view`;
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      const closeDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_GENMAIN',
        fieldName: 'F_CloseDate'
      });

      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 1;
        fastStorage[keyMatch].isClosed = true;
        fastStorage[keyMatch].closedBy = userID;
        fastStorage[keyMatch].closeDate = closeDate;
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 1;
        fastStorage[viewKeyMatch].isClosed = true;
        fastStorage[viewKeyMatch].closedBy = userID;
        fastStorage[viewKeyMatch].closeDate = closeDate;
      }
    }

    jobListContext.reloadData();
  }

  async function processAccountLock() {
    const accountLockResult = await appContext.api.accountClose(JobNames.OtherOP, selectedElement.id, !selectedElement.isAccountClosed);
    if (!!accountLockResult) {
      await showGlobalOkDialog(accountLockResult);
      return;
    }

    const hasOpened =
      jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/view/${selectedElement.id}`)


    if (selectedElement.isAccountClosed && hasOpened) {
      const editModelKey = `editOtherShipment${selectedElement.id}-/otherShipment/otherShipment/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewModelKey = `viewOtherShipment${selectedElement.id}-/otherShipment/otherShipment/view`;
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 0;
        fastStorage[keyMatch].isAccountClosed = false;
        fastStorage[keyMatch].accountClosedBy = '';
        fastStorage[keyMatch].accountCloseDate = null;
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 0;
        fastStorage[viewKeyMatch].isAccountClosed = false;
        fastStorage[viewKeyMatch].accountClosedBy = '';
        fastStorage[viewKeyMatch].accountCloseDate = null;
      }
    }else if (!selectedElement.isAccountClosed && hasOpened) {
      const editModelKey = `editOtherShipment${selectedElement.id}-/otherShipment/otherShipment/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewModelKey = `viewOtherShipment${selectedElement.id}-/otherShipment/otherShipment/view`;
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

       const accountCloseDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_GENMAIN',
        fieldName: 'F_AcctCloseDate'
      });

      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 1;
        fastStorage[keyMatch].isAccountClosed = true;
        fastStorage[keyMatch].accountClosedBy = userID;
        fastStorage[keyMatch].accountCloseDate = accountCloseDate;
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 1;
        fastStorage[viewKeyMatch].isAccountClosed = true;
        fastStorage[viewKeyMatch].accountClosedBy = userID;
        fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;
      }
    }

    jobListContext.reloadData();
  }

  function openContainerStatus() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(selectedElement.id);
  }

  function openContainerTracking() {
    window.open(`https://trackinginfo.suntekscm.com/?licid=${fmsGlobal.AcmeID}&search=${selectedElement.mblNo}`);
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock) && listSec?.grantEdit;
  let showAccountLock = (!selectedElement?.isAccountClosed ? getFmsGlobal().CanAccountLock : getFmsGlobal().CanAccountUnlock) && listSec?.grantEdit;
  let isTracking = (selectedElement?.trStatus && selectedElement?.trStatus !== 'C' && selectedElement?.trStatus !== 'failed' && selectedElement?.trStatus !== 'Q') ?? false;
  //const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.confirmDate??'') < (getFmsGlobal().CloseDate??'');
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Go to Container List', shortcut: 'F4', separator: false },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: noBillingsShow && noProfitShow, hidden: !listSec?.grantAdd },
    { label: 'Billings', shortcut: 'F7', separator: noProfitShow, hidden: noBillingsShow },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: noProfitShow},
    { label: 'Container Status Update', shortcut: '', separator: false },
    { label: 'CNTR Tracking Info', shortcut: '', separator: false },
    { label: isTracking ? 'Request Email Notification' : 'Request Tracking Service', shortcut: '', separator: false, hidden: !listSec?.grantEdit },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    { label: !selectedElement?.isAccountClosed ? 'Accounting Close' : 'Accounting Open', shortcut: '', separator: false, hidden: !showAccountLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize || !listSec?.grantEdit },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem  name="os-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        switchToContainerFor();
        break;
      case 5:
        jobListContext.triggerTableSearch('F5');
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 7:
        copy();
        break;
      case 8:
        viewBillings();
        break;
      case 9:
        viewProfit();
        break;
      case 10:
        openContainerStatus();
        break;
      case 11:
        openContainerTracking();
        break;
      case 12:
        trackRequestFunc();
        break;
      case 13:
        processFileLock();
        break;
      case 14:
        processAccountLock();
        break;
      case 15:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  return null;
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  
  const selectedElement = jobListContext.selectedElement as OtherOperationListItem;

  const {deleteItem, edit, view, copy, viewBillings, viewProfit, moveToDeleteHistoryReport, moveToRecogHistoryReport, trackRequestFunc} = useSelectedOperations();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const appContext = useContext(ApplicationContext);
  const { viewReport } = useReportViewer();
  const setSavedEntityJournal = useSetEditedId([JobNames.SlipJournal]);
  const {switchJournal} = useJournal();

  function doAfterRecog() {
    jobListContext.reloadData();
    setSavedEntityJournal(selectedElement.id.toString(), false);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/add`);
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.OtherOP, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }
  
  const allowedStatuses = ['', 'E', 'D'];

  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OtherOP, selectedElement?.branch);
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalOP, SecType.Read) && !userId?.startsWith('@');

  const hasSelectedRow = !!selectedElement;
  // const canBeDeleted = hasSelectedRow && !hasOpenedViewOrEditFor(selectedElement.id) && selectedElement.canBeDeleted
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);

  return (
    <div className='ifms-common-no-vertical-separator-gap-margin'>
       {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='os-list-add-button' display="primary" link="/otherShipment/otherShipment/add" disabled={!canBeAdd} label={<FontAwesomeIcon icon={faPlus} />} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='os-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
        <ViewIconButton2 name='os-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
        <DeleteIconButton2 name='os-list-delete-button' disabled={!canBeDeleted} onClick={deleteItem} useText/>
      </div>
      <div className='ifms-common-vertical-gap-8'>
        {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
        <PrimaryButton name='os-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
        {!noBillingsShow && <BillingsIconButton name='os-list-billings-button' data-tooltip={constants.List_Billings} onClick={viewBillings} useText/>}
        {!noProfitShow && <PrimaryButton name='os-list-profit-button' onClick={viewProfit} size="extrasmall" >Profit</PrimaryButton>}
        <DeleteHistoryIconButton onClick={moveToDeleteHistoryReport} useText/>
        <RecogHistoryIconButton onClick={moveToRecogHistoryReport} useText/>
        {!checkSecJournal && <JournalIconButton onClick={() => switchJournal(JobNames.OtherOP, selectedElement.id, "", null, selectedElement.refNo) } useText/> }
      </div> 
      {jobListContext.trackingRequestModalState && (
        <IfmsModal
          isBlueHeader
          cancelOnEsc
          onCancel={() => {
            const id = jobListContext.trackingRequestModalState?.jobId;
            if (id != null) fastStorage[`ot-container-trackrequest-${id}`] = null;
            jobListContext.setTrackingRequestModalState(undefined);
          }}
          draggable
          isOpen
          title={getTrackRequestTitle(jobListContext.trackingRequestModalState.trStatus)}
          width="500px"
        >
          <TrackingRequest
            jobId={jobListContext.trackingRequestModalState.jobId}
            storageKey={`ot-container-trackrequest-${jobListContext.trackingRequestModalState.jobId}`}
            onClose={() => {
              const id = jobListContext.trackingRequestModalState?.jobId;
              if (id != null) fastStorage[`ot-container-trackrequest-${id}`] = null;
              jobListContext.setTrackingRequestModalState(undefined);
            }}
            jobName={JobNames.OtherOP}
            trStatus={jobListContext.trackingRequestModalState.trStatus}
            trType={jobListContext.trackingRequestModalState.trType}
            mode={jobListContext.trackingRequestModalState.mode}
            vcResult={jobListContext.trackingRequestModalState.vcResult}
            containerNo={jobListContext.trackingRequestModalState.containerNo}
            prefetchedGroupData={jobListContext.trackingRequestModalState.prefetchedGroupData}
          />
        </IfmsModal>
      )}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.id} mTbName={"T_GENMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OtherOperationListItem;
  const history = useHistory();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OtherOP, selectedElement?.branch);

  const {copy, create, edit, view, viewBillings, viewProfit, switchToContainerFor} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);
    const fmsGlobal = getFmsGlobal();
  const noBillingsShow = !(fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = !(fmsGlobal.NoProfitShow ?? false);  

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === 'F4'){
      switchToContainerFor();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F7") {
      if(noBillingsShow)
        viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      if (noProfitShow)
        viewProfit();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F4', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const infoHeadline = `Ref #: ${(jobListContext.selectedElement as OtherOperationListItem|null)?.refNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.otherShipmentMbl}
      jobName={JobNames.OtherOP}
      //entityId={(jobListContext.selectedElement as OtherOperationListItem | null)?.id}
      jobId={(jobListContext.selectedElement as OtherOperationListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

function formatData(data:Array<OtherOperationListItem>) {
  return data.map(d => ({
    ...d,
    shipmentType: formatShipmentType(d.shipmentType ?? ''),
  }));
}

function AfterMemoLogButtonCommands() {
  const jobListContext = useContext(JobListViewContext);

  const selectedElement = jobListContext.selectedElement as OtherOperationListItem;
  const { trackRequestFunc} = useSelectedOperations();
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OtherOP, selectedElement?.branch);
  const hasSelectedRow = !!selectedElement;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  return  <IconButton style={{ alignItems: 'center', justifyContent: 'center' }} iconHeight="24px" data-tooltip='CNTR Tracking RQ' disabled={!canBeEdit} useOnlyIcon onClick={() => trackRequestFunc()} icon={appContext.useDarkMode ? TrackingRQIcon3_D : TrackingRQIcon3}/>;
}

/**
 * Concrete implementation for Other Shipment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.OtherOP,
      'OtherOperationListItem',
      OtherOperationListItem.calculateSearchParameters(search, OtherOperationListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.OtherOP, 'OtherOperationListItem',
      OtherOperationListItem.calculateSearchParameters(search, OtherOperationListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      // {
      //   accessor: 'recognized',
      //   renderer: RecognizedFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'trStatus',
        renderer: RQFilterEventRenderer,
        searchValueExtractor: (v:any|null|undefined) => v !== "" ? changeRQEvent(v): "",
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    return OtherOperationListItem.getExportCollection(useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if (x.dataIndex === 'pStatus') colRenderer.Cell = PaidRenderer;
      else if (x.dataIndex === 'useIsfNo') colRenderer.Cell = IsfRenderer;
      else if (x.dataIndex === 'itNo') colRenderer.Cell = InbondRenderer;
      else if(x.dataIndex === "shipmentType") colRenderer.Cell = ShipmentTypeRenderer;
      // else if (x.dataIndex === 'recognized') {
      //     colRenderer.Cell = RecognizedRenderer;
      // }
      else if(x.dataIndex === 'memoCnt') { colRenderer.Cell = MemoDetailRenderer;}
      else if(x.dataIndex === 'refNo') {colRenderer.Cell = RefNoRenderer;}
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      else if(x.dataIndex === "refNo") colRenderer.Cell = TextAlignLeftRenderer;
      else if(x.dataIndex === 'trStatus'){
        colRenderer.Cell = (props: any) => <LastEventRenderer {...props} jobName={JobNames.OtherOP} />;
        colRenderer.Header =  () => <div style={{gap:'4px', display:'flex'}}><img src={useDarkMode ? cntrGreen: cntrBlue} alt='' /><div>Container Tracking</div></div>;
      }
      else if(x.dataIndex === "agentName") colRenderer.Cell = AgentRenderer;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      else if(x.dataIndex === 'container') {
        colRenderer.Cell = ContainerRenderer;
      }
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    // colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    // colRenderer.push({ accessor: 'status', changedValue: (value: any) => { 
    //     const status = value['status'];
    //     return status === 'PC' ? 'Period Closeeeeee' :
    //            status === 'OC' ? 'OP Close' :
    //            status === 'AC' ? 'Acct Close' :
    //            '';
    // }});

    colRenderer.push({ accessor: 'useIsfNo', changedValue: (value: any)=> { return nullableCheckBoxValue(value['useIsfNo'])}});
    colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
    colRenderer.push({ accessor: 'lbs', changedValue: (value: any) => { return Decimalformat(value['lbs'],2) } });
    colRenderer.push({ accessor: 'kgs', changedValue: (value: any) => { return Decimalformat(value['kgs'],2) } });
    colRenderer.push({ accessor: 'shipmentType', changedValue: (value: any) => { return formatShipmentType(value['shipmentType']) } });
    colRenderer.push({accessor: 'trStatus', changedValue: (value: any)=> { return displayLastTrackingEvent(value)}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'postDate',
      orderByAscending: false,
    };
  }

  renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode | null {
    if (!rowId) return null;

    const selectedElement = context.selectedElement as OtherOperationListItem;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OtherOP, selectedElement?.branch);

    function onCloseMilestonePopup() {
      const storageKey = `ot-mbl-milestone-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onCloseMilestonePopup} draggable isOpen title="Container Status Update" width="760px">
        <MblMilestonePopup mblId={rowId} storageKey={`ot-milestone-${rowId}`} onClose={onCloseMilestonePopup} isView={!listSec?.grantEdit} />
      </IfmsModal>
    );
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  otherShipmentList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = OtherOperationListItem.getExportCollection(useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <ListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: OtherOperationListItem) {
    return row && row.id ? `/otherShipment/otherShipment/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Other Shipment List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.OtherOP} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
  
  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }
  
  useLogHistory(): boolean {
    return true;
  }
}

export default ListView;
